define("shared/utils/analytics/timezone-helpers/shift-time-to-start-of-local-day", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * @module Utils
   */

  /**
   * @class shiftTimeToStartOfLocalDay
   * @extends Utils
   */

  /**
   * Shifts a data point's time value to the start of the local day
   *
   * @method shiftTimeToStartOfLocalDay
   * @param {Number} time Unix time for any given data point
   *
   * @return {Number} Unix time shifted to start of local day, in ms.
   */
  const shiftTimeToStartOfLocalDay = (time, timeZoneIdentifier) => moment(time * 1000).tz(timeZoneIdentifier).startOf('day').valueOf();
  var _default = _exports.default = shiftTimeToStartOfLocalDay;
});